module.exports = __webpack_public_path__ + "img/engagement-photo-9.1be40994.jpg";